"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const Send_1 = __importDefault(require("@mui/icons-material/Send"));
const InputAdornment_1 = __importDefault(require("@mui/material/InputAdornment"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const helpers_1 = require("../../../common/helpers/helpers");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const globalVariables_1 = require("../../../common/globalVariables");
const services_1 = require("../../../common/services");
const ClientChatWrapper = styled_components_1.default.div `
  margin: 0 auto;
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (min-width: 1000px) {
    max-width: ${props => props.contentMaxWidth}px;
  }

  .scroll-root {
    height: calc(100% - 67px);
    overflow-y: auto;
    padding: 0 16px 16px 16px;
    &.offline {
      margin-top: 34px;
    }
  }

  .date-header {
    text-align: center;
    margin: 30px auto;
    z-index: 2;
    position: sticky;
    top: 10px;

    width: 160px;
    color: white;
    background-color: #d6d6d6;
    color: rgba(0, 0, 0, 60%);

    border-radius: 6px;
    padding: 4px;

    &:first-of-type {
      margin-top: 10px;
    }
  }
`;
const Message = styled_components_1.default.div `
  margin: 0 0 5px 0;
  display: flex;

  @media (max-width: 1000px) {
    p {
      font-size: 18px;
    }
  }

  a {
    text-decoration: underline !important;
    color: inherit;
  }

  .message-wrapper {
    border-radius: 10px;
    max-width: 80%;
    cursor: ${props => (props.hasLink ? 'pointer' : 'unset')};
  }

  .attached-content {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 50px;
    padding-right: 12px;
    margin: 3px 0 0 3px;
    border-bottom: 1px solid #ccc;
    border-top-left-radius: inherit;
  }

  &.guest-message {
    justify-content: end;
    .message-wrapper {
      background-color: ${props => props.theme.palette.mainAppColor.main};

      .message-text {
        color: ${props => props.theme.palette.mainAppColor.contrastText};
      }
    }
  }

  .message-text {
    white-space: pre-line;
    overflow-wrap: break-word;
  }

  &.admin-message {
    .message-wrapper {
      background-color: #f1f1f1;

      p,
      span {
        color: rgba(0, 0, 0, 87%);
      }
    }
  }

  &.guest-message + &.admin-message {
    margin-top: 20px;
  }

  &.admin-message + &.guest-message {
    margin-top: 20px;
  }

  .timestamp {
    text-align: right;
    display: block;
  }
`;
const TextWrapper = styled_components_1.default.div `
  padding: 6px 12px 6px 12px;
`;
const Inputs = styled_components_1.default.div `
  margin: 0px;
  padding-bottom: 16px;
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 3;
  padding: 16px;
  border-top: solid 1px rgba(0, 0, 0, 0.26);
  width: inherit;
  background-color: white;

  .MuiInputBase-multiline {
    padding: 10px 20px 10px 20px;
    border-radius: 22px;
  }

  .main-input {
    width: 100%;
  }
`;
const ItemImage = styled_components_1.default.div `
  background: linear-gradient(
    12deg,
    ${props => props.theme.palette.mainAppColor.dark} 5%,
    ${props => props.theme.palette.mainAppColor.light} 25%,
    ${props => props.theme.palette.mainAppColor.main} 100%
  );
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-image: ${props => (props.src ? `url(${props.src})` : null)};
  height: 100%;
  aspect-ratio: 1/1;
  border-top-left-radius: inherit;
`;
const ChatDetail = ({ messages, onSend, currentLocale, isOnline, userData }) => {
    const [input, setInput] = (0, react_1.useState)('');
    const [attachedContent, setAttachedContent] = (0, react_1.useState)({});
    const isMobile = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        const fetchContentForMessages = () => __awaiter(void 0, void 0, void 0, function* () {
            const newContentMap = Object.assign({}, attachedContent);
            // Loop over the messages and fetch additional content where needed
            for (const message of messages) {
                if (message.hasContent && !newContentMap[message.id]) {
                    const additionalContent = yield services_1.apiService.getMessageAttachment(currentLocale, userData.token, message.chatId, message.id);
                    newContentMap[message.id] = additionalContent;
                }
            }
            setAttachedContent(newContentMap);
        });
        fetchContentForMessages();
    }, [messages]);
    const updateSize = () => {
        const scrollElement = document.querySelector('.scroll-root');
        if (scrollElement) {
            scrollElement.scrollTop = scrollElement.scrollHeight;
        }
    };
    (0, react_1.useEffect)(() => {
        const inputs = document.querySelector('.chat-inputs');
        const resizeObserver = new ResizeObserver(() => {
            updateSize();
        });
        if (inputs) {
            resizeObserver.observe(inputs);
        }
        isMobile.current = !!helpers_1.Helpers.isMobile.iOS() || !!helpers_1.Helpers.isMobile.Android();
        return () => {
            if (inputs) {
                resizeObserver.unobserve(inputs);
            }
        };
    }, []);
    const handleSend = () => {
        if (!input) {
            return;
        }
        onSend({
            text: input,
            internal: false,
            close: false,
            setInput,
        });
    };
    const convertMessageTextToLink = text => {
        const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)/g;
        const replacer = match => {
            if (match.startsWith('http://') || match.startsWith('https://')) {
                return `<a href="${match}" target="_blank" rel="noopener noreferrer">${match}</a>`;
            }
            return `<a href="http://${match}" target="_blank" rel="noopener noreferrer">${match}</a>`;
        };
        return text.replace(urlRegex, replacer);
    };
    return (react_1.default.createElement(ClientChatWrapper, { className: "chat-wrapper", contentMaxWidth: globalVariables_1.WEB_APP.MAX_WIDTH_CONTAINER },
        react_1.default.createElement("div", { className: `scroll-root ${isOnline ? '' : 'offline'}` }, messages.map((message, index) => {
            const previousMessage = index === 0 ? { sentAt: '' } : messages[index - 1];
            const attachedChatMessage = attachedContent[message.id] && attachedContent[message.id].chatMessage;
            const attachedLink = attachedChatMessage && attachedContent[message.id].chatMessage.contentDeeplink;
            const attachedTitle = attachedChatMessage && attachedContent[message.id].chatMessage.contentTitle;
            const attachedIcon = attachedChatMessage && attachedContent[message.id].chatMessage.contentIconUrl;
            if (message.sentAt.slice(0, 10) !== previousMessage.sentAt.slice(0, 10)) {
                const date = helpers_1.Helpers.getDateFromStringDependingLocale(message.sentAt, currentLocale);
                const current = new Date(message.sentAt).toString().slice(0, 10);
                const today = new Date().toString().slice(0, 10);
                const isToday = today === current;
                const helper = new Date();
                helper.setDate(helper.getDate() - 1);
                const yesterday = helper.toString().slice(0, 10);
                const isYesterday = yesterday === current;
                let displayDate = date.date;
                if (isToday) {
                    displayDate = i18n_js_1.default.t('dictionary.dates.today');
                }
                if (isYesterday) {
                    displayDate = i18n_js_1.default.t('dictionary.dates.yesterday');
                }
                return (react_1.default.createElement(react_1.Fragment, { key: `${message.id}-${date.date}` },
                    react_1.default.createElement(material_1.Typography, { variant: "body2", className: `date-header ${isOnline ? '' : 'offline'}` },
                        ' ',
                        displayDate),
                    react_1.default.createElement(Message, { key: message.id, className: `message ${message.createdBy === 'guest' ? 'guest-message' : 'admin-message'}`, hasLink: attachedLink },
                        react_1.default.createElement("div", { className: "message-wrapper", onClick: () => {
                                if (attachedLink)
                                    window.open(attachedLink, '_blank', 'noopener,noreferrer');
                            } },
                            attachedChatMessage && (react_1.default.createElement("div", { className: "attached-content" },
                                react_1.default.createElement(ItemImage, { className: "item-image", src: attachedIcon }),
                                attachedTitle && react_1.default.createElement("p", null, attachedTitle))),
                            react_1.default.createElement(TextWrapper, null,
                                react_1.default.createElement(material_1.Typography, { variant: "body2", className: "message-text", dangerouslySetInnerHTML: { __html: message.text } }),
                                react_1.default.createElement(material_1.Typography, { variant: "caption", className: "message-text timestamp" }, helpers_1.Helpers.getDateFromStringDependingLocale(message.sentAt, currentLocale).time))))));
            }
            return (react_1.default.createElement(Message, { key: message.id, className: `message ${message.createdBy === 'guest' ? 'guest-message' : 'admin-message'}`, hasLink: attachedLink },
                react_1.default.createElement("div", { className: "message-wrapper", onClick: () => {
                        if (attachedLink)
                            window.open(attachedLink, '_blank', 'noopener,noreferrer');
                    } },
                    attachedChatMessage && (react_1.default.createElement("div", { className: "attached-content" },
                        react_1.default.createElement(ItemImage, { className: "item-image", src: attachedIcon }),
                        attachedTitle && react_1.default.createElement("p", null, attachedTitle))),
                    react_1.default.createElement(TextWrapper, null,
                        react_1.default.createElement(material_1.Typography, { variant: "body2", className: "message-text", dangerouslySetInnerHTML: {
                                __html: convertMessageTextToLink(message.text),
                            } }),
                        react_1.default.createElement(material_1.Typography, { variant: "caption", className: "message-text timestamp" }, helpers_1.Helpers.getDateFromStringDependingLocale(message.sentAt, currentLocale).time)))));
        })),
        react_1.default.createElement(Inputs, { className: "chat-inputs" },
            react_1.default.createElement(material_1.TextField, { id: "chat-input", onChange: evt => {
                    setInput(evt.target.value);
                }, onBlur: () => {
                    if (helpers_1.Helpers.isMobile.iOS()) {
                        const chatPage = document.querySelector('.chat-page');
                        if (chatPage) {
                            chatPage.classList.remove('keyboard-open');
                        }
                    }
                }, onFocus: () => {
                    if (helpers_1.Helpers.isMobile.iOS()) {
                        const chatPage = document.querySelector('.chat-page');
                        if (chatPage) {
                            chatPage.classList.add('keyboard-open');
                        }
                    }
                }, disabled: !isOnline, color: "mainAppColor", InputProps: {
                    endAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "end" },
                        react_1.default.createElement(IconButton_1.default, { color: "mainAppColor", disabled: input.length === 0, "aria-label": "chat-inputs", onMouseDown: evt => {
                                handleSend();
                                evt.preventDefault();
                            }, edge: "end" },
                            react_1.default.createElement(Send_1.default, null)))),
                }, onKeyPress: evt => {
                    // 13 = enter key
                    if (!isMobile.current && evt.charCode === 13 && !evt.shiftKey) {
                        handleSend();
                        evt.preventDefault();
                    }
                }, value: input, className: "main-input", multiline: true, maxRows: 5, placeholder: i18n_js_1.default.t('write_a_message') }))));
};
const mapStoreToProps = store => ({
    currentLocale: store.getValue('currentLocale'),
    userData: store.getValue('userData'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(ChatDetail);
